import type { Icon } from '../../../src/lib/types'
export const mdiArrowLeft: Icon = {
  "id": "arrow-left",
  "name": "Arrow Left",
  "path": "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z",
  "as": [
    "arrow-back"
  ],
  "tags": [
    "Arrow"
  ]
}
export default mdiArrowLeft